var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNetworkTransgression(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 936 807.97",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{letter-spacing:-.01em;}.cls-2{font-size:25.43px;}.cls-2,.cls-3,.cls-4{font-family:MyriadPro-Regular, 'Myriad Pro';}.cls-5{fill:url(#linear-gradient);}.cls-6{letter-spacing:0em;}.cls-7{letter-spacing:0em;}.cls-8{letter-spacing:0em;}.cls-9{letter-spacing:0em;}.cls-10,.cls-4{fill:#fff;}.cls-11{letter-spacing:0em;}.cls-12{letter-spacing:0em;}.cls-13{letter-spacing:0em;}.cls-14{letter-spacing:0em;}.cls-15{letter-spacing:0em;}.cls-3,.cls-4{font-size:21px;}.cls-16{letter-spacing:0em;}.cls-17{letter-spacing:0em;}.cls-18{fill:none;stroke:#000;stroke-miterlimit:10;}.cls-19{letter-spacing:0em;}.cls-20{letter-spacing:0em;}.cls-21{letter-spacing:0em;}.cls-22{letter-spacing:-.03em;}.cls-23{letter-spacing:.01em;}.cls-24{letter-spacing:-.03em;}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 257.5,
    y1: 733,
    x2: 832.5,
    y2: 733,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.74,
    stopColor: "#000"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 257,
    cy: 396,
    r: 102.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257,294c56.24,0,102,45.76,102,102s-45.76,102-102,102-102-45.76-102-102,45.76-102,102-102m0-1c-56.89,0-103,46.11-103,103s46.11,103,103,103,103-46.11,103-103-46.11-103-103-103h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 50,
    cy: 217,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,168c27.02,0,49,21.98,49,49s-21.98,49-49,49S1,244.02,1,217s21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 449,
    cy: 568,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,519c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 50,
    cy: 568,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50,519c27.02,0,49,21.98,49,49s-21.98,49-49,49S1,595.02,1,568s21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 449,
    cy: 217,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,168c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 175.5,
    y1: 332.5,
    x2: 86.5,
    y2: 251.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 328.5,
    y1: 322.5,
    x2: 416.5,
    y2: 255.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 336.5,
    y1: 461.5,
    x2: 409.5,
    y2: 536.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 79.5,
    y1: 527.5,
    x2: 176.5,
    y2: 460.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 620,
    cy: 217,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,168c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 449,
    cy: 50,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M449,1c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49S421.98,1,449,1m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50S476.61,0,449,0h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 620,
    cy: 50,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M620,1c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49S592.98,1,620,1m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50S647.61,0,620,0h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 483.5,
    y1: 180.5,
    x2: 583.5,
    y2: 83.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 498.5,
    y1: 216.5,
    x2: 569.5,
    y2: 216.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 448.5,
    y1: 166.5,
    x2: 448.5,
    y2: 99.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 783,
    cy: 568,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M783,519c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-10",
    cx: 619,
    cy: 568,
    r: 49.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M619,519c27.02,0,49,21.98,49,49s-21.98,49-49,49-49-21.98-49-49,21.98-49,49-49m0-1c-27.61,0-50,22.39-50,50s22.39,50,50,50,50-22.39,50-50-22.39-50-50-50h0Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 257.5,
    y: 692.5,
    width: 575,
    height: 81
  }), /*#__PURE__*/React.createElement("path", {
    d: "M832,693v80H258v-80H832m1-1H257v82H833v-82h0Z"
  })), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 498.5,
    y1: 567.5,
    x2: 568.5,
    y2: 567.5
  }), /*#__PURE__*/React.createElement("line", {
    className: "cls-18",
    x1: 668.5,
    y1: 567.5,
    x2: 732.5,
    y2: 567.5
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(416 802.72)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "ne"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 22.18,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 29.32,
    y: 0
  }, "w"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 44.56,
    y: 0
  }, "o"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-7",
    x: 56.09,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 63.04,
    y: 0
  }, "k t"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-6",
    x: 84.29,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    x: 91.05,
    y: 0
  }, "ans"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-16",
    x: 121.15,
    y: 0
  }, "g"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-20",
    x: 132.76,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 139.42,
    y: 0
  }, "ession difficul"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-19",
    x: 258.93,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 266.07,
    y: 0
  }, "y")), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(754.86 577.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "epoch")), /*#__PURE__*/React.createElement("polygon", {
    points: "257 367.66 241.79 376.21 226.58 367.66 226.58 350.55 241.79 342 257 350.55 257 367.66"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "295.76 367.57 280.54 376.12 265.33 367.57 265.33 350.46 280.54 341.91 295.76 350.46 295.76 367.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "463.76 575.57 448.54 584.12 433.33 575.57 433.33 558.46 448.54 549.91 463.76 558.46 463.76 575.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "315.76 432.57 300.54 441.12 285.33 432.57 285.33 415.46 300.54 406.91 315.76 415.46 315.76 432.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "219.76 367.57 204.54 376.12 189.33 367.57 189.33 350.46 204.54 341.91 219.76 350.46 219.76 367.57"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(189.37 397.33)"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "seed dist"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-8",
    x: 77.68,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-21",
    x: 84.63,
    y: 0
  }, "ibu"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-9",
    x: 113.06,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 119.89,
    y: 0
  }, "or")), /*#__PURE__*/React.createElement("text", {
    className: "cls-2",
    transform: "translate(362.21 466.69) rotate(45.77) scale(.97 1)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-1",
    x: 0,
    y: 0
  }, "v"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.98,
    y: 0
  }, "e"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-23",
    x: 24.72,
    y: 0
  }, "c"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-14",
    x: 36.44,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 44.7,
    y: 0
  }, "or")), /*#__PURE__*/React.createElement("rect", {
    x: 715.5,
    y: 553.5,
    width: 352,
    height: 89,
    transform: "translate(1489.5 -293.5) rotate(90)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-4",
    transform: "translate(883.16 540.88) rotate(90)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-22",
    x: 0,
    y: 0
  }, "V"), /*#__PURE__*/React.createElement("tspan", {
    x: 11.03,
    y: 0
  }, "alue "), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-24",
    x: 52.65,
    y: 0
  }, "F"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-11",
    x: 62.33,
    y: 0
  }, "il"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-15",
    x: 72.2,
    y: 0
  }, "t"), /*#__PURE__*/React.createElement("tspan", {
    x: 79.02,
    y: 0
  }, "er")), /*#__PURE__*/React.createElement("polygon", {
    points: "461.76 224.57 446.54 233.12 431.33 224.57 431.33 207.46 446.54 198.91 461.76 207.46 461.76 224.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "634.76 56.57 619.54 65.12 604.33 56.57 604.33 39.46 619.54 30.91 634.76 39.46 634.76 56.57"
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "717.64 589 700.65 580 683.7 589.09 686.89 569.91 673.12 556.37 692.09 553.53 700.54 536.07 709.07 553.49 728.05 556.24 714.35 569.84 717.64 589"
  }), /*#__PURE__*/React.createElement("text", {
    className: "cls-3",
    transform: "translate(668.75 526.95)"
  }, /*#__PURE__*/React.createElement("tspan", {
    className: "cls-17",
    x: 0,
    y: 0
  }, "M"), /*#__PURE__*/React.createElement("tspan", {
    x: 17.01,
    y: 0
  }, "a"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-12",
    x: 27.13,
    y: 0
  }, "r"), /*#__PURE__*/React.createElement("tspan", {
    className: "cls-13",
    x: 34.08,
    y: 0
  }, "ker")))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNetworkTransgression);
export default __webpack_public_path__ + "static/media/network-transgression.e94831befc482183adf40e640e38680a.svg";
export { ForwardRef as ReactComponent };